import cx from 'classnames';
import * as React from 'react';

import MediaObject from 'components/MediaObject';
import Row from 'components/Row';
import Text from 'components/Text';

import './OrganizationEngagementViewChartFigure.scss';

type Props = {
  chartType: 'communication' | 'reach';
  children: React.ReactNode;
  copy: string;
  title: React.ReactNode;
};

export default function OrganizationEngagementViewChartFigure({
  chartType,
  children,
  copy,
  title,
}: Props) {
  return (
    <MediaObject
      center
      gutter="xxxxlarge"
      className={cx(
        'OrganizationEngagementViewChartFigure',
        `OrganizationEngagementViewChartFigure--${chartType}`
      )}>
      <div className="OrganizationEngagementViewChartFigure-chart">
        <Text color="graphite" size="xxxsmall">
          {children}
        </Text>
      </div>
      <div>
        <Row size="small">
          <Text element="h3" size="xlarge" weight="semibold">
            {title}
          </Text>
        </Row>
        <Text element="p" size="medium">
          {copy}
        </Text>
      </div>
    </MediaObject>
  );
}
